import { QueryClient } from '@tanstack/react-query';
import { toast } from '../hooks/use-toast';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Data is immediately considered stale to ensure it's always refetched
      gcTime: 1000 * 60 * 30, // Keep in memory for 30 mins
      refetchOnWindowFocus: true, // Refetch when window is focused to stay sync'd
      retry: (failureCount, error: any) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      onError: (error: any) => {
        toast({
          title: 'Error',
          description: error?.message || 'An unexpected error occurred',
          variant: 'destructive',
        });
      },
      retry: false,
    },
  },
});
